// @core/stores/webhook/WebhookWebhookStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { webhookApi } from '@core/api';
import type {
  PublishEventRequest,
  PublishEventResponse,
  PublishEventsRequest,
  PublishEventsResponse,
} from '@core/types/webhook';

class WebhookWebhookStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Publish event
   */
  async PublishEvent(data: PublishEventRequest): Promise<PublishEventResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await webhookApi.PublishEvent(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Publish events
   */
  async PublishEvents(data: PublishEventsRequest): Promise<PublishEventsResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await webhookApi.PublishEvents(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const webhookWebhookStore = new WebhookWebhookStore();
